/**
 * streamlines add a dynamic value to maxWidth.
 * @param {object} param0
 * @param {string} param0.$maxWidth
 * @returns {string}
 */
const dynMaxWidth = ({ $maxWidth }) => {
  if ($maxWidth === undefined) return "";
  if (typeof $maxWidth === "number") return `max-width: ${$maxWidth}px;`;
  return `max-width: ${$maxWidth};`;
};

export default dynMaxWidth;
